//@ts-check
import { createSlice } from '@reduxjs/toolkit'
import instance from "utils/axios";
import { endPoint } from "src/AppConstants";

/**
 * @type import('./d3Graph').GraphState
 */
const initialState = {
    loggedinData: null
};


const d3GraphSlice = createSlice({
    name: 'classes',
    initialState: initialState,
    reducers: {

        /**
        * @param  {  {payload: import('./d3Graph').DateCount[]  }} action
        */
        setLoggedInData(state, action) {
            state.loggedinData = action.payload;
        }
    },

});



const fetchLoggedInData = (classId) => async (dispatch, getState) => {

    instance.get(endPoint.GET_CLASS_LOGGED_IN_STAT_URL(classId))
        .then(response => {
            dispatch(d3GraphDuck.setLoggedInData(response.data));
        });
}



export const d3GraphDuck = {
    ...d3GraphSlice.actions,
     fetchLoggedInData
};

export default d3GraphSlice.reducer